<script lang="ts">
  import { productCategoryMapping } from "$lib/types/products";
  interface Props {
    filters?: string[];
    activeFilter?: string;
    search?: string;
  }

  let { filters = [], activeFilter = "", search = "" }: Props = $props();
</script>

<p class="mt-2 font-600 mb-2">Filtrer utvalg</p>

<ul class="list-none flex flex-wrap gap-2 p-0 mt-2 laptop:mb-12">
  <li>
    <a
      data-sveltekit-noscroll
      class="button"
      class:button-selected={activeFilter === "nettbutikk"}
      href={`/nettbutikk${search}`}
      rel={search ? "nofollow" : undefined}
    >
      Vis alle
    </a>
  </li>
  {#each filters as filter (filter)}
    <li>
      <a
        data-sveltekit-noscroll
        class="button capitalize"
        class:button-selected={filter === activeFilter}
        href={`/nettbutikk/kategori/${filter}${search}`}
        rel={search ? "nofollow" : undefined}
      >
        {productCategoryMapping.find((a) => a.key === filter)?.value || filter}
      </a>
    </li>
  {/each}
</ul>
